import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	validUrl: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	validUrl: {
		id: 'issue-field-url-inline-edit-full.url.valid-url',
		defaultMessage: 'Please enter a valid URL.',
		description: 'Invalid URL when user enters javascript:// forbidden urls.',
	},
});
export default messages;
